import { render, staticRenderFns } from "./UserAgreementManager.vue?vue&type=template&id=52c2bc0f&scoped=true"
import script from "./UserAgreementManager.vue?vue&type=script&lang=js"
export * from "./UserAgreementManager.vue?vue&type=script&lang=js"
import style0 from "./UserAgreementManager.vue?vue&type=style&index=0&id=52c2bc0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c2bc0f",
  null
  
)

export default component.exports